import './Support.css';

export const Support = () => {
    return (
        <div>Support</div>
    );
};